<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.4565 22.5C19.5924 22.5 20.5217 21.6 20.5217 20.5V4.5C20.5217 3.4 19.5924 2.5 18.4565 2.5H12.2609V9.5L9.67935 8L7.09783 9.5V2.5H6.06522C4.92935 2.5 4 3.4 4 4.5V20.5C4 21.6 4.92935 22.5 6.06522 22.5H18.4565Z"
				:stroke="color"
				stroke-width="1.56"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBookClosed',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
